import React from 'react';

const ProgressIcon = ({className}) => (
  <svg className={className} viewBox="0 0 225 228" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1858_4143)" filter="url(#filter0_d_1858_4143)">
      <g filter="url(#filter1_d_1858_4143)">
        <path fillRule="evenodd" clipRule="evenodd" d="M111.5 206C159.825 206 199 166.825 199 118.5C199 70.1753 159.825 31 111.5 31C63.1752 31 24 70.1753 24 118.5C24 166.825 63.1752 206 111.5 206Z" fill="black" fillOpacity="0.01"/>
        <path d="M191.5 118.5C191.5 162.683 155.683 198.5 111.5 198.5C67.3173 198.5 31.5 162.683 31.5 118.5C31.5 74.3174 67.3173 38.5 111.5 38.5C155.683 38.5 191.5 74.3175 191.5 118.5Z" stroke="#E8EEF4" strokeOpacity="0.3" strokeWidth="15"/>
      </g>
      <path d="M168.5 174.5C183 158.5 190.5 143.5 191.5 122C191.5 71.5 156.325 38.5 108 38.5" stroke="#00D9CD" strokeWidth="15" strokeLinecap="round"/>
      <g opacity="0.95" filter="url(#filter2_d_1858_4143)">
        <circle cx="111.5" cy="118.5" r="66.5" fill="white"/>
      </g>
      <g filter="url(#filter3_d_1858_4143)">
        <path fillRule="evenodd" clipRule="evenodd" d="M111.5 59.0002C123.926 59.0002 134 48.9264 134 36.5002C134 24.0737 123.926 14 111.5 14C99.0737 14 89.0001 24.0737 89.0001 36.5002C89.0001 48.9264 99.0737 59.0002 111.5 59.0002Z" fill="#00D9CD"/>
      </g>
      <path fillRule="evenodd" clipRule="evenodd" d="M115.387 31.5594V31.5594V31.5594L109.367 37.5797V37.5797L107.613 35.8904V35.8904L107.58 35.8581C106.736 35.0136 105.371 35.0136 104.527 35.8581V35.8581C103.683 36.7024 103.683 38.0673 104.527 38.9114L104.559 38.9439V38.9439L107.807 42.1925V42.1925V42.1925C108.634 43.0544 109.985 43.0687 110.829 42.2246L110.861 42.1925V42.1925L118.441 34.6127V34.6127L118.457 34.5966C119.31 33.7433 119.303 32.371 118.441 31.5267L118.425 31.5109C117.571 30.6754 116.214 30.6968 115.387 31.5594Z" fill="white"/>
    </g>
    <defs>
      <filter id="filter0_d_1858_4143" x="0" y="0" width="225" height="228" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="85" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1858_4143"/>
        <feOffset dx="1" dy="7"/>
        <feGaussianBlur stdDeviation="7.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.34902 0 0 0 0 0.843137 0 0 0 0 0.811765 0 0 0 0.1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1858_4143"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1858_4143" result="shape"/>
      </filter>
      <filter id="filter1_d_1858_4143" x="-1" y="16" width="225" height="225" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="10"/>
        <feGaussianBlur stdDeviation="12.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.330297 0 0 0 0 0.409583 0 0 0 0 1 0 0 0 0.3 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1858_4143"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1858_4143" result="shape"/>
      </filter>
      <filter id="filter2_d_1858_4143" x="20" y="37" width="183" height="183" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="10"/>
        <feGaussianBlur stdDeviation="12.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.330297 0 0 0 0 0.409583 0 0 0 0 1 0 0 0 0.3 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1858_4143"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1858_4143" result="shape"/>
      </filter>
      <filter id="filter3_d_1858_4143" x="64" y="-1" width="95" height="95" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="10"/>
        <feGaussianBlur stdDeviation="12.5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.330297 0 0 0 0 0.409583 0 0 0 0 1 0 0 0 0.3 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1858_4143"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1858_4143" result="shape"/>
      </filter>
      <clipPath id="clip0_1858_4143">
        <rect width="225" height="228" fill="white"/>
      </clipPath>
    </defs>
  </svg>

);

export default ProgressIcon;
